export const resetOnClick = (onChange, value, name) => {
  if (value === 0) {
    onChange({
      target: {
        name: name,
        value: '',
      },
    });
  }
}